import { React, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getSwitchExchangeToken } from '../appswitch/AppSwitchSaga';
import { PARAMETER_FOR_APP_SWITCH_REDIRECT_URL, INTEGRATION_ROUTES } from '../constants/constants';
import BasicCard from '../../components/card/basiccard/BasicCard';
import styles from './ImportSection.styles';
import { VEC_ICON_NAME } from '../../components/icons/constants';
import Icons from '../../components/icons/Icons';
import Heading from '../../components/heading/Heading';
import Button from '../../components/button/Button';
import { BUTTON_TYPE } from '../../components/button/constants';
import { Routes, useNavigate } from 'react-router-dom';
import { BUTTON_HOVER_TOOLTIPS } from './constants';
import Popup from '../../components/popup/Popup';


function IntegrationPagesView() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getIntegrationsPage = (iconName) => {
        switch (iconName) {
            case VEC_ICON_NAME.XERO_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.XERO}`);
                break;
            case VEC_ICON_NAME.FRESH_BOOKS_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.FRESHBOOKS}`);
                break;
            case VEC_ICON_NAME.EXCEL_IMPORT_LOGO:
                navigate(`/${INTEGRATION_ROUTES.FORMS}/${INTEGRATION_ROUTES.IMPORT}`);
                break;
            case VEC_ICON_NAME.QUICK_BOOKS_ONLINE_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.QBO}`);
                break;
            case VEC_ICON_NAME.SAGE_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.SAGE}`);
                break;
            case VEC_ICON_NAME.ORACLE_NETSUITE_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.NETSUITE}`);
                break;
            case VEC_ICON_NAME.QUICK_BOOKS_DESKTOP_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.QBD}`);
                break;
            case VEC_ICON_NAME.ZOHO_BOOKS_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.ZOHO}`);
                break;
            case VEC_ICON_NAME.TIPALTI_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.TIPALTI}`);
                break;
            case VEC_ICON_NAME.BILL_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.BILL}`);
                break;
            case VEC_ICON_NAME.ENTRATA_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.ENTRATA}`);
                break;
            case VEC_ICON_NAME.ACCOUNTING_SUITE_LOGO:
                navigate(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.ACCOUNTINGSUITE}`);
                break;
            default:
                handlePopup();
                break;
        }
    };

    const handlePopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const integrationLogoButtons = [
        { iconName: VEC_ICON_NAME.EXCEL_IMPORT_LOGO, note: BUTTON_HOVER_TOOLTIPS.EXCEL_IMPORT_TITLE },
        { iconName: VEC_ICON_NAME.QUICK_BOOKS_DESKTOP_LOGO, note: BUTTON_HOVER_TOOLTIPS.NOT_IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.QUICK_BOOKS_ONLINE_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.BILL_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.XERO_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.ZOHO_BOOKS_LOGO, note: BUTTON_HOVER_TOOLTIPS.NOT_IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.SAGE_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.ORACLE_NETSUITE_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.ENTRATA_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.FRESH_BOOKS_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE  },
        { iconName: VEC_ICON_NAME.ACCOUNTING_SUITE_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.TIPALTI_LOGO, note: BUTTON_HOVER_TOOLTIPS.NOT_IMPLEMENTED_TITLE },
        { iconName: VEC_ICON_NAME.BILL_LOGO, note: BUTTON_HOVER_TOOLTIPS.IMPLEMENTED_TITLE },
    ];

    return (
        <div style={styles.container}>
            <div style={styles.columnsContainer}>
                <div style={{ ...styles.column }}>
                    <Heading type="h2" customStyle={{ ...styles.cardHeading, }}>
                        The eFiling Platform with 10+ Integration Partners
                    </Heading>
                    {isPopupOpen && (
                        <Popup
                            title="Feature Not Yet Implemented. Click Below to Go to Classic App."
                            isPopupOpen={isPopupOpen}
                            onCloseCb={closePopup}
                            customPopupSyles={styles.popupContainer}
                        >
                            <>
                                <p style={styles.popupParagraph}>
                                    Classic view contains the full set of integrations and import features.
                                    <Button
                                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                        onClickCb={() => dispatch(getSwitchExchangeToken({ source: PARAMETER_FOR_APP_SWITCH_REDIRECT_URL.IMPORT }))}
                                        style={styles.classicButtonStyle}
                                    >
                                        Click here to redirect to the classic view
                                    </Button>
                                </p>
                            </>
                        </Popup>
                    )}
                    <BasicCard fullWidth={true} customStyles={styles.cardCustomStyles}>
                        <div style={styles.leftColInnerDiv}>
                            <div style={{ ...styles.colInnerDivTopSec }}>
                                <div style={styles.logoButtonStyle}>
                                    {integrationLogoButtons.slice(0, 6).map((button, index) => (
                                        <Button
                                            key={index}
                                            type={BUTTON_TYPE.PRIMARY}
                                            style={styles.integrationButtonStyle}
                                            title={button.note}
                                            onClickCb={() => getIntegrationsPage(button.iconName)}
                                        >
                                            <Icons
                                                familyName="vec"
                                                iconName={button.iconName}
                                                style={styles.iconSize}
                                            />
                                            {button.iconName}
                                        </Button>
                                    ))}
                                </div>
                                <div style={styles.logoButtonStyle}>
                                    {integrationLogoButtons.slice(6, 12).map((button, index) => (
                                        <Button
                                            key={index}
                                            type={BUTTON_TYPE.PRIMARY}
                                            style={styles.integrationButtonStyle}
                                            title={button.note}
                                            onClickCb={() => getIntegrationsPage(button.iconName)}
                                        >
                                            <Icons
                                                familyName="vec"
                                                iconName={button.iconName}
                                                style=
                                                {
                                                    button.iconName === VEC_ICON_NAME.FRESH_BOOKS_LOGO ?
                                                        styles.iconSizeFreshBooks : button.iconName === VEC_ICON_NAME.ACCOUNTING_SUITE_LOGO ?
                                                            styles.iconSizeAccountingsuite : styles.iconSize
                                                }
                                            />
                                            {button.iconName}
                                        </Button>
                                    ))}
                                </div>
                                <Heading type="h3" customStyle={styles.buttonHeading}>
                                    <div style={styles.classicNoteStyle}>
                                        <div>
                                            Classic view contains the full set of integrations and import features.
                                        </div>
                                        <Button
                                            type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                            onClickCb={() => dispatch(getSwitchExchangeToken({ source: PARAMETER_FOR_APP_SWITCH_REDIRECT_URL.IMPORT }))}
                                            style={styles.classicButtonStyle}
                                        >
                                            Click here to redirect to the classic view
                                        </Button>
                                    </div>
                                </Heading>
                            </div>
                        </div>
                    </BasicCard>
                </div>
            </div>
        </div>
    );
}

export default IntegrationPagesView;
